<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="shift.id ? '编辑' : '新建'"
      width="1200px"
      @close="resetForm"
  >
    <el-form
        ref="form"
        :model="shift"
        :rules="ruleValidate"
        label-width="150px"
        label-suffix=" :">
      <div class="fm-section-title">基本信息</div>
      <el-row :gutter="10">
        <el-col v-if="shift.id" :span="12">
          <el-form-item label="班次编码">
            <el-input v-model="shift.shiftCode" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班次名称" prop="shiftName">
            <el-input v-model="shift.shiftName"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班次类型" prop="shiftType">
            <el-select v-model="shift.shiftType" clearable>
              <el-option v-for="item in shiftTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="shiftStatus">
            <el-select v-model="shift.shiftStatus" clearable>
              <el-option v-for="item in shiftStatusOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">时间设置</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="上班时间">
            <el-time-picker v-model="shift.workStart" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下班时间">
            <el-time-picker v-model="shift.workEnd" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="休息开始">
            <el-time-picker v-model="shift.restStart" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="休息结束">
            <el-time-picker v-model="shift.restEnd" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效时长(小时)">
            <el-input-number v-model="shift.effectWorkHour" :min="0" :precision="1" controls-position="right"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">加班设置</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="允许加班">
            <el-select v-model="shift.canOvertime" clearable>
              <el-option v-for="item in overtimeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最大加班时长(小时)">
            <el-input-number v-model="shift.overtimeMaxHour" :min="0" :precision="1" controls-position="right"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">备注</div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="shift.remark" type="textarea" :rows="3"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        shiftTypeOptions: [
          { label: "白班", value: 1 },
          { label: "中班", value: 2 },
          { label: "晚班", value: 3 },
          { label: "混合多班", value: 4 },
        ],
        shiftStatusOptions: [
          { label: "禁用", value: 0 },
          { label: "启用", value: 1 },
        ],
        overtimeOptions: [
          { label: "否", value: 0 },
          { label: "是", value: 1 },
        ],
        shift: {},
        ruleValidate: {
          shiftName: { required: true, message: "请输入班次名称", trigger: "blur" },
          shiftType: { required: true, message: "请选择班次类型", trigger: "change" },
          shiftStatus: { required: true, message: "请选择状态", trigger: "change" },
        },
      };
    },
    methods: {
      resetForm() {
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row) {
        this.dialogVisible = true;
        this.shift = Object.assign(
          {
            id: undefined,
            shiftName: "",
            shiftCode: "",
            shiftType: 1,
            workStart: "08:00:00",
            workEnd: "17:00:00",
            restStart: "12:00:00",
            restEnd: "13:00:00",
            effectWorkHour: 8,
            canOvertime: 1,
            overtimeMaxHour: undefined,
            shiftStatus: 1,
            remark: "",
          },
          row || {}
        );
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            let request;
            if (this.shift.id) {
              // 编辑：PUT /fm/calendarShift/{shiftId}
              request = this.$http.put("basic", `fm/calendarShift/${this.shift.id}`, this.shift);
            } else {
              // 新增：POST /fm/calendarShift
              request = this.$http.post("basic", "fm/calendarShift", this.shift);
            }
            request
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success(this.shift.id ? "编辑成功" : "添加成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
